import APIService from "@/services/api-factory";

export default class SitesService {
    static getAll = APIService.get('/sites/all');
    static getByGuid = guid => (APIService.get(`/site/${guid}`))();
}
